import { Obstruction } from '../obstruction.class';
import { Vertex3 } from '../../../spatial-classes';

export const getCenterOffsetsCfn = (island: Obstruction, angle = 0, includeCountertop = false): { front: number; left: number; back: number; right: number; } => {
	const offsets = { front: 0, left: 0, back: 0, right: 0 };

	try {
		island.panels.children.forEach((p) => {
			const side = p.getSidePoints({ includeCountertop, translate: true, rotate: true }).corners;
			const zero = new Vertex3();

			side[0].rotateAxis(zero, angle, 'y');
			side[0].roundNearestSixteenth();

			side[1].rotateAxis(zero, angle, 'y');
			side[1].roundNearestSixteenth();

			offsets.front = Math.min(offsets.front, side[0].z, side[1].z);
			offsets.left = Math.min(offsets.left, side[0].x, side[1].x);
			offsets.back = Math.max(offsets.back, side[0].z, side[1].z);
			offsets.right = Math.max(offsets.right, side[0].x, side[1].x);
		});
	} catch (error) {
		console.error(`getCenterOffsetsCfn:Error calculating center offsets for island ${island.id}:`, error);
	}

	return offsets;
}
